import { TranscriptTurnDtoSpeaker, type TranscriptTurnDto } from '@sara/api-client';
import { formatTurnOffset } from '../InterviewBriefDetail/format';

interface SessionTurnProps {
  turn: TranscriptTurnDto;
  sessionStartedAt: string | null;
}

export function SessionTurn({ turn, sessionStartedAt }: SessionTurnProps) {
  const isAi = turn.speaker === TranscriptTurnDtoSpeaker.SARA;
  const speakerLabel = isAi ? 'AI Interviewer' : 'Candidate';
  const offset = formatTurnOffset(turn.startedSpeakingAt, sessionStartedAt);

  return (
    <article className="grid grid-cols-[7rem_1fr] gap-6 py-5">
      <div className="flex flex-col gap-1">
        <span
          className={
            isAi
              ? 'text-[11px] font-medium uppercase tracking-[0.06em] text-primary'
              : 'text-[11px] font-medium uppercase tracking-[0.06em] text-muted-foreground/80'
          }
        >
          {speakerLabel}
        </span>
        {offset && (
          <time className="font-mono text-[11px] tabular-nums text-muted-foreground/70">
            {offset}
          </time>
        )}
      </div>
      <p className="text-[14.5px] leading-relaxed text-foreground/90">{turn.content}</p>
    </article>
  );
}
